import React, { useEffect, useRef, useState } from "react";
import Loader from "../Loader";
import CenterTitle from "../CenterTitle";

interface ComponentProps {
  data;
  filterBy?;
  children;
  active: boolean;
  action: ({ page }: { page: number }) => void;
  isLoading: boolean;
  page: number;
  style?;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  noMessage?: boolean;
}

const FetchDataComponent = ({
  filterBy,
  data,
  children,
  isLoading,
  page,
  setPage,
  active,
  action,
  style,
  noMessage,
}: ComponentProps) => {
  const observer = useRef<IntersectionObserver | null>(null); // Define observer type
  useEffect(() => {
    action({ page });
  }, []);

  const lastElementRef = useRef<HTMLDivElement>(null); // Define ref type

  useEffect(() => {
    console.log(data, isLoading, page, active, "datasc");
    if (!isLoading && data) {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0,
      };

      const handleIntersect: IntersectionObserverCallback = async (entries) => {
        if (entries[0].isIntersecting && active) {
          action({ page: page + 1 });
          setPage(page + 1);
        }
      };

      observer.current = new IntersectionObserver(handleIntersect, options);

      if (lastElementRef.current) {
        observer.current.observe(lastElementRef.current);
      }
      return () => {
        if (lastElementRef.current) {
          observer.current?.unobserve(lastElementRef.current); // Use optional chaining for observer unobserve
        }
      };
    }
  }, [data, isLoading]);
  return (
    <div style={!!style ? style : {}} className="infinityScroll">
      {children}
      {isLoading && <Loader color="Primary" />}
      {!active && !isLoading && !noMessage && (
        <CenterTitle mg={5} title="No hay más elementos"></CenterTitle>
      )}
      <div ref={lastElementRef}></div>
    </div>
  );
};

export default FetchDataComponent;
